module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_23.0f634e3b.png";